import { Tabs, Tab, makeStyles } from '@material-ui/core'
import { DashboardType, MyTaskPermissions, Permission, TaskCount, TaskType, TeamTaskPermissions } from '@pulseops/common'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { StyleProp, StyleSheet, Text, View, ViewStyle } from 'react-native'
import { Type } from './TaskGroupTabs'

const useStyles = makeStyles({
  root: {
    '& .MuiTabs-fixed': {
      // borderRadius: 16,
      // boxShadow: 'none',
      // backgroundColor: 'blue',
      // shadowColor: '#0F0',
      borderBottom: '1px solid #C4C4C4'
    },
    '& .MuiTab-root': {
      // set style for child component
      lineHeight: 1,
      minHeight: 35,
      minWidth: 60,
      maxWidth: '100%',
      textTransform: 'capitalize',
      // margin: '0px 10px',
      marginRight: 25,
      paddingLeft: '1px',
      paddingRight: '1px',
      paddingTop: '6px',
      paddingBottom: '4px'
    },
    '&.MuiTabs-root': {
      // set style for root component
      minHeight: 35
    }
  },
  indicator: {
    backgroundColor: '#ed1b2e',
    // width: '100%',
  },
})

export const checkCategoryPermission = (taskType: TaskType, type: DashboardType, permissions: string[]) => {
  let basketPermission: { [key: string]: Permission } = {}

  switch (taskType) {
    case TaskType.PolicyService:
      basketPermission = type === DashboardType.TeamTask ? TeamTaskPermissions.PS : MyTaskPermissions.PS
      break
    case TaskType.DistributionService:
      basketPermission = type === DashboardType.TeamTask ? TeamTaskPermissions.DS : MyTaskPermissions.DS
      break
    case TaskType.Complaint:
      basketPermission = type === DashboardType.TeamTask ? TeamTaskPermissions.CH : MyTaskPermissions.CH
      break
    case TaskType.Claim:
      basketPermission = type === DashboardType.TeamTask ? TeamTaskPermissions.CL : MyTaskPermissions.CL
      break
    case TaskType.CustomerService:
      basketPermission = type === DashboardType.TeamTask ? TeamTaskPermissions.CS : MyTaskPermissions.CS
      break
    case TaskType.Underwriting:
      basketPermission = type === DashboardType.TeamTask ? TeamTaskPermissions.UW : MyTaskPermissions.UW
      break
    case TaskType.PremiumCollection:
      basketPermission = type === DashboardType.TeamTask ? TeamTaskPermissions.PC : MyTaskPermissions.PC
      break
    case TaskType.ErrorHandler:
      basketPermission = type === DashboardType.TeamTask ? TeamTaskPermissions.EH : {}
      break
    case TaskType.IDC:
      basketPermission = type === DashboardType.TeamTask ? TeamTaskPermissions.IDC : MyTaskPermissions.IDC
      break
  }

  const hasPermission =
    permissions.filter((p) => Object.values(basketPermission).includes(p as Permission)).length > 0

  if (taskType === TaskType.ErrorHandler) {
    return (
      hasPermission &&
      permissions.includes(
        type === DashboardType.TeamTask
          ? TeamTaskPermissions.ViewErrorHandlerTeamTask
          : MyTaskPermissions.ViewErrorHandlerMyTask
      )
    )
  }

  return hasPermission
}

export type TaskCategoryTabProps = {
  type: DashboardType
  dataSource: TaskCount[]
  onChangeTab: (taskGroup: TaskCount) => void
  activeTabValue?: TaskCount
  permissions: string[]
  containerStyle?: StyleProp<ViewStyle>
}

export const TaskCategoryTab = (props: TaskCategoryTabProps) => {
  const { t } = useTranslation('TaskManagement')
  const { activeTabValue, dataSource, onChangeTab, type, permissions, containerStyle } = props
  const classes = useStyles()

  // console.log('activeTabValue:'+ JSON.stringify(activeTabValue))

  const handleChange = (event: React.ChangeEvent<{}>, value: TaskCount) => {
    onChangeTab(value)
  }



  const tabList = React.useMemo(() => {
    const customedData = !!dataSource && dataSource.length > 0 ? dataSource.filter((item) => checkCategoryPermission(item.type, type, permissions)) : []
    // console.log('customedData:' + JSON.stringify(customedData))
    return customedData
  }, [dataSource])

  const getTabLabel = (isActive: boolean, label: (converter: (val: string) => string) => string, count?: number) => {
    return (
      <View style={tabStyles.tabContent}>
        <View><Text style={[tabStyles.inactiveText, isActive && tabStyles.activeText]}>{label(t)}</Text></View>
        {count !== undefined && count >= 0 &&
          <View style={tabStyles.tabCircleContent}>
            <Text style={tabStyles.tabCircleText}>{count}</Text>
          </View>}
      </View>
    )
  }
  return (
    <View style={containerStyle}>
      {!!activeTabValue && tabList && tabList.length > 0 && (
        <Tabs
          value={activeTabValue}
          // indicatorColor="primary"
          textColor="primary"
          onChange={handleChange}
          aria-label="simple tabs example"
          classes={{
            root: classes.root, indicator: classes.indicator
          }}
          TabIndicatorProps={{
            style: {
              transition: 'none'
            }
          }}
        >
          {tabList && tabList.length > 0 &&
            tabList.map((dataItem, index) => {
              return (
                <Tab
                  key={`dataItem_${index}`}
                  label={getTabLabel(activeTabValue?.type === dataItem.type, dataItem.label, dataItem.value)}
                  value={dataItem}
                  disableRipple
                ></Tab>
              )
            })}
        </Tabs>
      )}

    </View>

  )
}
const tabStyles = StyleSheet.create({
  activeText: {
    // color: '#ED1B2E'
    color: '#4F4F4F',
    fontSize: 15,
    fontFamily: 'NotoSans_400Regular',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: 24
  },
  tabContent: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row'
  },
  tabCircleContent: {
    marginLeft: 4,
    minWidth: 24,
    height: 24,
    borderRadius: 24,
    borderWidth: 1,
    borderColor: '#ED1B2E',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 3
  },
  tabCircleText: {
    color: '#ED1B2E',
    fontFamily: 'NotoSans_400Regular',
    lineHeight: 20
  },
  inactiveText: {
    color: '#4F4F4F',
    fontSize: 15
  }
})

